// pages/ForgotPassword.tsx
import { useState } from "react"
import { supabase } from "../lib/supabase"

export default function ForgotPassword() {
  const [email, setEmail] = useState("")
  const [message, setMessage] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)

  const handleResetRequest = async () => {
    setLoading(true)
    setMessage(null)

    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: window.location.origin + "/reset-password",
    })

    if (error) {
      setMessage("Erreur : " + error.message)
    } else {
      setMessage("📬 Link has been sent to your email.")
    }

    setLoading(false)
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#f9fbfd] to-[#e7eff8] px-4">
      <div className="bg-white w-full max-w-md p-8 rounded-3xl shadow-lg border border-slate-100">
        <h1 className="text-2xl font-bold text-center text-slate-800 mb-6">🔑 Forgot password</h1>
        <p className="text-sm text-gray-600 mb-4 text-center">
          Enter your email address to receive a reset link!
        </p>

        <input
          type="email"
          placeholder="you@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full px-4 py-2 mb-4 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-primary"
        />

        <button
          onClick={handleResetRequest}
          disabled={loading}
          className="w-full py-2 bg-primary hover:bg-opacity-90 text-white font-semibold rounded-md transition disabled:opacity-60"
        >
          {loading ? "Sending..." : "Send it"}
        </button>

        {message && <p className="mt-4 text-sm text-center text-gray-700">{message}</p>}
      </div>
    </div>
  )
}
